// Debug logging at the very top
console.log('Loop Widget V2 script loaded');

// Safari-specific check
if (navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')) {
    console.log('Safari detected, applying Safari-specific fixes');
}

function initializeLoopWidgetV2() {
    console.log('DOM Content Loaded - Loop Widget V2');
    
    // Check if script is already initialized
    if (window.loopWidgetV2Initialized) {
        console.log('Loop Widget V2 already initialized, skipping...');
        return;
    }
    
    // Mark as initialized
    window.loopWidgetV2Initialized = true;
    const all_variable_inputs = document.querySelectorAll('input[name="Quantity"]');
    const sellingPlanInputs = document.querySelectorAll('input[name="selling_plan_option"]');
    const sellingPlanSelectors = document.querySelectorAll('select.frequency-plan-selector');
    
    console.log('Elements found:', {
        quantityInputs: all_variable_inputs.length,
        sellingPlanInputs: sellingPlanInputs.length,
        sellingPlanSelectors: sellingPlanSelectors.length
    });

    sellingPlanInputs.forEach(sellingPlanInput => {
        sellingPlanInput.addEventListener("change", function (e) {
            let sellingPlanContainer = e.target.closest(".subscriptions-wrapper");
            if (sellingPlanContainer ) {
                let allWrappers = document.querySelectorAll(".subscriptions-wrapper");
                allWrappers.forEach(elem => {
                    elem.classList.remove('hide-elements');
                });
            } else {
                let allWrappers = document.querySelectorAll(".subscriptions-wrapper");
                allWrappers.forEach(elem => {
                    elem.classList.add('hide-elements');
                });
            }
            let option_index = sellingPlanInput.getAttribute("data-purchase-index");
            if (!option_index && sellingPlanInput.classList.contains('one-time-option-radio')) {
                option_index = document.querySelector('input[name="Quantity"]:checked').getAttribute('data-index');
                let oneTimeVariants = document.querySelectorAll('.one-time-variants-container');
                oneTimeVariants.forEach(el => el.style.display = "block");
                let subscriptionVariants = document.querySelectorAll('.subscriptions-variants-container');
                subscriptionVariants.forEach(el => el.style.display = "none");
                let frequencySelectors = document.querySelectorAll('.frequency-selector');
                frequencySelectors.forEach(el => el.style.display = "none");
                let informationWrappers = document.querySelectorAll('.information-wrapper');
                informationWrappers.forEach(el => el.style.display = "none");
                let separators = document.querySelectorAll('separator');
                separators.forEach(el => el.style.display = "none");
            } else {
                let oneTimeVariants = document.querySelectorAll('.one-time-variants-container');
                oneTimeVariants.forEach(el => el.style.display = "none");
                let subscriptionVariants = document.querySelectorAll('.subscriptions-variants-container');
                subscriptionVariants.forEach(el => el.style.display = "block");
                let frequencySelectors = document.querySelectorAll('.frequency-selector');
                frequencySelectors.forEach(el => el.style.display = "block");
                let informationWrappers = document.querySelectorAll('.information-wrapper');
                informationWrappers.forEach(el => el.style.display = "block");
                let separators = document.querySelectorAll('separator');
                separators.forEach(el => el.style.display = "block");
            }
            unselectAll(all_variable_inputs);
            variantLabelUpdate(e.target, option_index);
            updateButtonPrice();
            const masterSelect = document.querySelector("select.master_select");
            const selectedVariantId = masterSelect.querySelector(`option[data-variant-index="${option_index}"]`).value;
            updateSellingPlan(selectedVariantId);
        });
    });

    function handleQuantityChange(e) {
        const dataIndex = e.target.getAttribute('data-index');
        const purchaseContainer = e.target.closest(".one-time-wrapper, .subscriptions-wrapper");
        if (!dataIndex || !purchaseContainer) return;

        unselectAll(sellingPlanInputs);
        const selectedVariantId = updateMasterSelect(dataIndex);

        if (purchaseContainer.classList.contains('subscriptions-wrapper')) {
            const selectedPurchaseContainer = document.querySelector(
                `.subscriptions-wrapper.variant-related-${selectedVariantId}`
            ) || purchaseContainer;
            const purchaseOption = selectedPurchaseContainer.querySelector('input[name="selling_plan_option"]');
            if (purchaseOption) {
                purchaseOption.checked = true;
            }
            unselectAll(all_variable_inputs);
            const selectedQuantityInput = selectedPurchaseContainer.querySelector(`input[data-index="${dataIndex}"]`);
            if (selectedQuantityInput) {
                selectedQuantityInput.checked = true;
            }
            hideAllPlans();
            selectedPurchaseContainer.style.display = "block";
        } else {
            hideAllPlans();
            const oneTimeOption = purchaseContainer.querySelector('.one-time-option-radio');
            if (oneTimeOption) {
                oneTimeOption.checked = true;
            }
            const subscriptionsToShow = document.querySelectorAll(`input[data-purchase-index="${dataIndex}"]`);
            subscriptionsToShow.forEach(element => element.closest(".subscriptions-wrapper").style.display = "block");
        }

        updateButtonPrice();
    }

    all_variable_inputs.forEach(quantityInput => {
        quantityInput.addEventListener("change", handleQuantityChange);
    });

    sellingPlanSelectors.forEach(sellingPlanSelector => {
        sellingPlanSelector.addEventListener("change", function (e) {
            document.querySelector('input[name="selling_plan"]').value = e.target.value;
            updateURLWithSellingPlan(e.target.value);
            updateButtonPrice();
            const perks = document.querySelectorAll('.information-wrapper li');
            perks.forEach( perk => {
                if (!perk.classList.contains('shared-data')) {
                    perk.style.display = "none"
                }
            });
            let updatePerks = document.querySelectorAll(`.information-wrapper li.perk-${e.target.value}`);
            updatePerks.forEach( updatePerk => updatePerk.style.display = "flex");
            const planText = e.target.querySelector(`option[value="${e.target.value}"]`).text;
            document.querySelector('.sticky-bar-plan-text').textContent = planText;
            document.querySelector('input.sticky-selling-plan').value = e.target.value;
        });
    });
    
    document.querySelectorAll('[data-loop-quantity-selector]').forEach(selector => {
        selector.disabled = false;
    });
    document.querySelectorAll('[data-loop-purchase-option]').forEach(option => {
        option.disabled = false;
    });
    document.documentElement.classList.add('loop-widget-v2-ready');

    const selectedPurchaseOption = document.querySelector('input[name="selling_plan_option"]:checked');
    if (selectedPurchaseOption) {
        updateButtonPrice();
        const subscriptionContainer = selectedPurchaseOption.closest('.subscriptions-wrapper');
        const selectedPlanSelector = subscriptionContainer?.querySelector('select.frequency-plan-selector');
        if (selectedPlanSelector) {
            const selectedPlanId = selectedPlanSelector.value;
            const selectedPlanText = selectedPlanSelector.selectedOptions[0]?.textContent || '';
            document.querySelector('input[name="selling_plan"]').value = selectedPlanId;
            document.querySelector('input.sticky-selling-plan').value = selectedPlanId;
            document.querySelector('.sticky-bar-plan-text').textContent = selectedPlanText;
        }
    }

    console.log('Loop Widget V2 initialization completed successfully');
}

// The script is deferred, so the product form normally exists before this runs.
// Keep the DOMContentLoaded fallback for cached/legacy script tags.
if (document.querySelector('input[name="Quantity"]')) {
    initializeLoopWidgetV2();
} else {
    document.addEventListener('DOMContentLoaded', initializeLoopWidgetV2, { once: true });
}

function unselectAll(inputs){
    inputs.forEach(input => {
        if (input && typeof input.checked !== 'undefined') {
            input.checked = false;
        }
    });
}

function variantLabelUpdate(target, option_index) {
    const container = 
        target.closest(".one-time-wrapper") ||
        target.closest(".subscriptions-wrapper");
    container.querySelector(`input[data-index="${option_index}"]`).checked = true;
}

function hideAllPlans(){
    const subscriptionsToHide = document.querySelectorAll('.subscriptions-wrapper');
    subscriptionsToHide.forEach(element => element.style.display = "none");
}

function updateMasterSelect(optionSelected){
    const masterSelect = document.querySelector("select.master_select");
    const selectedVariantId = masterSelect.querySelector(`option[data-variant-index="${optionSelected}"]`).value;
    masterSelect.value = selectedVariantId;
    updateSellingPlan(selectedVariantId);
    updateURLWithVariant(selectedVariantId);
    const oneTimePrices = document.querySelectorAll('.one-time-price.price-wrapper');
    oneTimePrices.forEach(oneTimePrice => oneTimePrice.style.display = "none");
    document.querySelector(`.one-time-price.price-variant-${selectedVariantId}`).style.display = "block";
    document.querySelector('input.sticky-variant').value = selectedVariantId;
    return selectedVariantId;
}

function updateButtonPrice() {
    const purchaseOptionSelected = document.querySelector('input[name="selling_plan_option"]:checked');
    const masterSelect = document.querySelector("select.master_select");
    const selectedOption = masterSelect?.selectedOptions[0];
    if (!purchaseOptionSelected || !selectedOption) return;

    let purchaseOptionContainer = '';
    let priceElement = null;
    if (purchaseOptionSelected.closest(".one-time-wrapper")) {
        purchaseOptionContainer = purchaseOptionSelected.closest(".one-time-wrapper");
        priceElement = purchaseOptionContainer.querySelector(
            `.one-time-price.price-variant-${selectedOption.value} #price-one-time-original`
        );
    } else if (purchaseOptionSelected.closest(".subscriptions-wrapper")) {
        purchaseOptionContainer = purchaseOptionSelected.closest(".subscriptions-wrapper");
        priceElement = purchaseOptionContainer.querySelector('#price-subscription-original');
    }
    if (!priceElement) return;

    const price = priceElement.innerHTML;
    const addToCartEl = document.querySelector('.add-to-cart');
    const stickyAddToCartPriceEl = document.querySelector('.sticky-add-to-cart-bar__price');
    const stickyAddToCartVariantDescriptionEl = document.querySelector('.sticky-add-to-cart-bar__variant-description');
    if (stickyAddToCartVariantDescriptionEl) {
        const variantDescription = selectedOption.getAttribute('data-sticky-variant-description') || '';
        stickyAddToCartVariantDescriptionEl.textContent = variantDescription;
        stickyAddToCartVariantDescriptionEl.hidden = !variantDescription;
    }
    if (selectedOption.hasAttribute('data-available') && selectedOption.getAttribute('data-available') === 'false') {
        addToCartEl.innerHTML = 'Sold Out';
        stickyAddToCartPriceEl.innerHTML = price;
        return;
    }
    addToCartEl.innerHTML = 'Add to cart - ' + price;
    stickyAddToCartPriceEl.innerHTML = price;
}
function updateSellingPlan(variantSelected) {
    const sellingPlanContainer = document.querySelector(`.variant-related-${variantSelected}`);
    let sellingPlanId = '';
    setTimeout(() => {
        if (document.querySelector('input.one-time-option-radio:checked')) {
            document.querySelector('input[name="selling_plan"]').value = ''; 
            document.querySelector('input.sticky-selling-plan').value = '';
            sellingPlanId = '';
        } else {
            sellingPlanId = sellingPlanContainer.querySelector('select.frequency-plan-selector').value;
            const planText = sellingPlanContainer.querySelector(`select.frequency-plan-selector option[value="${sellingPlanId}"]`).textContent;
            document.querySelector('.sticky-bar-plan-text').textContent = planText;
            document.querySelector('input[name="selling_plan"]').value = sellingPlanId;
            document.querySelector('input.sticky-selling-plan').value = sellingPlanId;
        }
        if (sellingPlanId !== ''){
            const perks = document.querySelectorAll('.information-wrapper li');
            perks.forEach( perk => {
                if (!perk.classList.contains('shared-data')) {
                    perk.style.display = "none";
                }
            });
            let updatePerks = document.querySelectorAll(`.information-wrapper li.perk-${sellingPlanId}`);
            updatePerks.forEach( updatePerk => updatePerk.style.display = "flex");
        }
        updateURLWithSellingPlan(sellingPlanId);
    }, 100);
}

function updateURLWithVariant(variantId) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('variant', variantId);
    window.history.pushState({}, '', currentUrl.toString());
    const urlChangeEvent = new CustomEvent('variantUrlChanged', {
        detail: { variantId: variantId }
    });
    document.dispatchEvent(urlChangeEvent);
}

function updateURLWithSellingPlan(sellingPlanId) {
    const currentUrl = new URL(window.location.href);
    if (sellingPlanId && sellingPlanId !== '') {
        currentUrl.searchParams.set('selling_plan', sellingPlanId);
    } else {
        currentUrl.searchParams.delete('selling_plan');
    }
    window.history.pushState({}, '', currentUrl.toString());
    const urlChangeEvent = new CustomEvent('sellingPlanUrlChanged', {
        detail: { sellingPlanId: sellingPlanId }
    });
    document.dispatchEvent(urlChangeEvent);
}
